import styled from 'styled-components';
import {backgroundCss} from '../../styles/background.styled';
import {textCss} from '../../styles/text.styled';
import {alignCss} from '../../styles/align.styled';
import {boxCss} from '../../styles/box.styled';


export const PageContainer = styled.div`
  width: 100%;
  margin: 0;
  padding: 24px;
  ${alignCss};
  ${backgroundCss};
  ${textCss};
  ${boxCss};


`;

PageContainer.defaultProps = {};

